module.exports = __webpack_public_path__ + "dc73f50bc48244f0fdeebf3d45b3ba45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/accreditation@3x.jpg
// module id = 643
// module chunks = 0